import OrderTotal from 'components/OrderConfirmation/OrderTotal/OrderTotal';
import withGlobalModals from 'hocs/withGlobalModals';

const ConnectedOrderTotal = withGlobalModals(OrderTotal);

export default ConnectedOrderTotal;
